// Fonts first
import '@fontsource/space-mono/400.css'
import '@fontsource/space-mono/700.css'
import '@fontsource/space-mono/400-italic.css'
import '@fontsource/space-mono/700-italic.css'

// Your global styles
import './src/normalize.css'
import './src/carousel.css'
import './src/styles/globals.css'

import rootWrapper from './rootWrapper'
export const wrapPageElement = rootWrapper